export enum SolarFacialType {
  MONOFACIAL = 'MONOFACIAL',
  BIFACIAL = 'BIFACIAL',
}
export const solarFacialTypeToLabel = {
  [SolarFacialType.MONOFACIAL]: 'Monofacial',
  [SolarFacialType.BIFACIAL]: 'Bifacial',
};
